import { Container, Box, Typography, List, ListItem, ListItemIcon, ListItemText, Paper, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Environment } from 'utils/environment';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DownloadIcon from '@mui/icons-material/Download';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AndroidIcon from '@mui/icons-material/Android';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  maxWidth: '800px',
  margin: '0 auto',
  backgroundColor: theme.palette.background.paper,
}));

const ContactItem = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  marginBottom: theme.spacing(1),
  borderRadius: '8px',
  backgroundColor: theme.palette.grey[50],
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Help = () => {
  const apkFileName =  Environment.APKFileName;
  const apkDownloadUrl = `/files/${encodeURIComponent(apkFileName)}`;

  return (
    <Container component="main" maxWidth="md" sx={{ py: 4, minHeight: 'calc(100vh - 64px - 48px)' }}>
      <StyledPaper elevation={0}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Box 
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <HelpOutlineIcon sx={{ fontSize: 80, color: '#343c89' }} />
          </Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 2, color: '#343c89' }}>
            Ayuda y Soporte
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto', mb: 4 }}>
            ¿Tienes preguntas o necesitas soporte técnico? Nuestro equipo está listo para ayudarte.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
            Contáctanos
          </Typography>
          <List disablePadding>
            <ContactItem>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <MailOutlineIcon sx={{ color: '#343c89' }} />
              </ListItemIcon>
              <ListItemText 
                primary="Email" 
                secondary="servicedesk@impressarepuestos.com"
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ContactItem>
            <ContactItem>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <WhatsAppIcon sx={{ color: '#25D366' }} />
              </ListItemIcon>
              <ListItemText 
                primary="WhatsApp" 
                secondary="+503 77407781"
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ContactItem>
            <ContactItem>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <AccessTimeIcon sx={{ color: '#343c89' }} />
              </ListItemIcon>
              <ListItemText 
                primary="Horario de Atención" 
                secondary="Lunes a Viernes 7:30AM a 6:00PM"
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ContactItem>
          </List>
        </Box>

        <Box 
          sx={{ 
            backgroundColor: '#ffffff', 
            p: 3, 
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          <MenuBookIcon sx={{ fontSize: 40 , color: '#343c89'}} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5, color: 'text.primary' }}>
              Manual de Usuario
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              Consulta nuestro manual para obtener respuestas detalladas sobre el uso de la plataforma.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
              <Button
                component="a"
                href="/docs/manual_geo_web.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.5,
                  borderRadius: '8px',
                  backgroundColor: '#ffffff',
                  color: '#343c89',
                  border: '2px solid #343c89',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#343c89',
                    color: '#ffffff',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    borderColor: '#343c89'
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                Descargar Manual WEB
              </Button>
              <Button
                component="a"
                href="/docs/manual_geo_app.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.5,
                  borderRadius: '8px',
                  backgroundColor: '#ffffff',
                  color: '#343c89',
                  border: '2px solid #343c89',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#343c89',
                    color: '#ffffff',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    borderColor: '#343c89'
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                Descargar Manual APP
              </Button>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 3,
            backgroundColor: '#ffffff',
            p: 3,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
          }}
        >
          <AndroidIcon sx={{ fontSize: 40, color: '#3ddc84' }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5, color: 'text.primary' }}>
              Aplicación Android
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              Descarga la app móvil de Karthus para gestionar dispositivos desde tu teléfono.
            </Typography>
            <Button
              component="a"
              href={apkDownloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              download={apkFileName}
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.5,
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                color: '#343c89',
                border: '2px solid #343c89',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: '#343c89',
                  color: '#ffffff',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  borderColor: '#343c89',
                },
                '&:active': {
                  transform: 'translateY(0)',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                },
              }}
            >
              Descargar APK
            </Button>
          </Box>
        </Box>
      </StyledPaper>
    </Container>
  );
};
